import { render } from "./StaffPage_home.vue?vue&type=template&id=1929b9df&scoped=true"
import script from "./StaffPage_home.vue?vue&type=script&lang=js"
export * from "./StaffPage_home.vue?vue&type=script&lang=js"

import "./StaffPage_home.vue?vue&type=style&index=0&id=1929b9df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1929b9df"]])

export default __exports__